module.exports = __webpack_public_path__ + "static/DisabledTripWasCut-2729a279dbc3ed09acf1d73d80dedf00.png";